import { render } from "./GroupedPlayersBox.vue?vue&type=template&id=780f37b4&scoped=true"
import script from "./GroupedPlayersBox.vue?vue&type=script&lang=js"
export * from "./GroupedPlayersBox.vue?vue&type=script&lang=js"

import "./GroupedPlayersBox.vue?vue&type=style&index=0&id=780f37b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780f37b4"]])

export default __exports__